var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteWheelIconTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D72929",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M0 0h17.001v17H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M2.507 12.243l6.051-6.088 6.128 6.094 1.009-1.025L8.548 4.12l-7.063 7.111 1.022 1.012z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteWheelIconTop);
export default __webpack_public_path__ + "static/media/white-wheel-icon-top.605da56a669c4650efb81ceee6b4c82e.svg";
export { ForwardRef as ReactComponent };